import { render, staticRenderFns } from "./table.vue?vue&type=template&id=53dcdb1e&scoped=true&"
import script from "./table.vue?vue&type=script&lang=ts&"
export * from "./table.vue?vue&type=script&lang=ts&"
import style0 from "./table.vue?vue&type=style&index=0&id=53dcdb1e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53dcdb1e",
  null
  
)

export default component.exports